const PERMISSION_KEY= "core:global_config";
const PAGE_URL = {
    GLOBAL_CONFIG_PAGE: "/admin/core/global-config"
}

export {PERMISSION_KEY, PAGE_URL}

